import MainLayout from '@layouts/main-layout/main-layout';
import type { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';
import VacanciesComponent from '@components/careers/vacancies/vacancies';
import { getVacancies } from '@services/vacancy.services';
import { getSpecialities } from '@services/speciality.service';
import Head from 'next/head';
import { MetaTags } from '@helpers/meta-tags.helper';

const Careers: NextPage = ({
  vacancies,
  vacanciesTotal,
  specialities,
  specialitiesTotal,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return (
    <>
      <Head>
        {MetaTags({
          title: 'Jobs at Agilie | Discover Agilie’s work opportunities and find your dream job.',
          description:
            'Mentoring. Professional development opportunities. Open-door policy. Friendly working environment. Work from home or in the office. Regular meetups and workshops with resident consultants. Individual development plans.',
          imageUrl: '/vacancies-images/career-meta-image.png',
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <MainLayout>
        <VacanciesComponent
          vacancies={vacancies}
          vacanciesTotal={vacanciesTotal}
          specialities={specialities}
          specialitiesTotal={specialitiesTotal}
        />
      </MainLayout>
    </>
  );
};

export default Careers;

export const getServerSideProps: GetServerSideProps = async () => {
  const [vacancies, specialities] = await Promise.all([getVacancies(0, 100), getSpecialities(0, 100)]);
  return {
    props: {
      vacancies: vacancies.data,
      vacanciesTotal: vacancies.total,
      specialities: specialities.data,
      specialitiesTotal: specialities.total,
    },
  };
};
